import retry from 'async-retry';
import { logError } from 'packages/lib/utils/logger';

export const withRetry = <T>(
  fn: () => Promise<T>,
  errorMessage?: string,
  retries = 3
): Promise<T> =>
  retry(() => fn(), {
    onRetry: (err, attempt) => {
      if (attempt > retries - 1 && errorMessage) {
        logError(err);
      }
    },
    retries,
  });
